<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-cog', fontSet: 'fad'}"
	[headerText]="T.SELECT_PLAYERS_DIALOG_ADD | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		@if (!loadingRooms) {
			<div [@zoomInOnEnter] class="colorLegend">
				<div class="colorLegendCon">
					<div class="indicator ready">
						<i class="fad fa-check-double"></i>
					</div>
					<div class="text">
						{{ T.PLAYER_STATUS_READY_TO_CONNECT | translate }}
					</div>
				</div>
				<div class="colorSeperator"></div>
				<div class="colorLegendCon">
					<div class="indicator busy">
						<i class="fad fa-signal-stream"></i>
					</div>
					<div class="text busy">
						{{ T.PLAYER_STATUS_ALREADY_IN_USE | translate }}
					</div>
				</div>
				<div class="colorSeperator"></div>
				<div class="colorLegendCon">
					<div class="indicator recording">
						<i class="fad fa-signal-stream"></i>
					</div>
					<div class="text busy">
						{{ T.PLAYER_STATUS_ALREADY_IN_USE_RECORDING | translate }}
					</div>
				</div>
				<div class="colorSeperator"></div>
				<div class="colorLegendCon">
					<div class="indicator offline">
						<i class="fad fa-wifi-slash"></i>
					</div>
					<div class="text">
						{{ T.PLAYER_STATUS_OFFLINE | translate }}
					</div>
				</div>
			</div>
		}

		@if (!loadingRooms) {
			<div [@listStagger]="liveStreamRooms?.length" class="allLiveStreamRooms">
				@for (liveStreamRoom of liveStreamRooms; track liveStreamRoom) {
					<ng-container *ngVar="isRoomInUse(liveStreamRoom) as isRoomInUse">
						<ng-container *ngVar="getPlayerStatusClass(liveStreamRoom) as playerStatus">
							<div
								(click)="liveStreamRoomClicked(liveStreamRoom)"
								*ngVar="isRoomSelected(liveStreamRoom) as isRoomSelectedVar"
								[class.disabled]="isRoomInUse"
								[class.roomSelected]="isRoomSelectedVar"
								[matTooltipDisabled]="!isRoomInUse"
								[matTooltip]="
									T.PLAYER_USED_BY_RECORDER
										| translate
											: {
													recorderName: getRoomInUseByRecorder(liveStreamRoom)?.name,
											  }
								"
								class="liveStreamRoom {{ playerStatus }}"
								mat-ripple
							>
								<div class="icon">
									<sim-animated-material-icon
										[biggerFAIcon]="true"
										[endIcon]="{
											fontSet: 'fad',
											fontIcon: 'fa-check',
											themeColor: 'accent',
										}"
										[startIcon]="{
											fontSet: 'fad',
											fontIcon: 'fa-door-open',
											themeColor: 'white',
										}"
										[trigger]="isRoomSelectedVar"
									/>
								</div>
								<div class="roomName showDotsOnOverflow1">
									{{ liveStreamRoom.name }}
								</div>
								<div class="statusIcon {{ playerStatus }}">
									@switch (playerStatus) {
										@case ("offline") {
											<i [@zoomInOnEnter] [@zoomOutOnLeave] class="fad fa-wifi-slash"></i>
										}
										@case ("busy") {
											<i [@zoomInOnEnter] [@zoomOutOnLeave] class="fad fa-signal-stream"></i>
										}
										@case ("recording") {
											<i [@zoomInOnEnter] [@zoomOutOnLeave] class="fad fa-signal-stream"></i>
										}
										@case ("ready") {
											<i [@zoomInOnEnter] [@zoomOutOnLeave] class="fad fa-check-double"></i>
										}
									}
								</div>
							</div>
						</ng-container>
					</ng-container>
				}
			</div>
		}

		@if (loadingRooms) {
			<div class="loadingConHolder" style="height: 200px; position: relative">
				<sim-component-loading-container
					[isLoading]="loadingRooms"
					[loadingIcon]="'fad fa-door-open'"
					[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
					[showBackDrop]="false"
				/>
			</div>
		}
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel', selectedPlayerIds: []})"
			[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CANCEL"
			[color]="'warn'"
		/>

		<sim-button (onClick)="saveConfig()" [icon]="{fontSet: 'fad', fontIcon: 'fa-check'}" [label]="T.BUTTON_OK" [color]="'accent'" />
	</ng-container>
</sim-basic-material-dialog>
